import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LoadingStatus } from 'src/app/core/domain/events/state_provider';

import { Dietitian } from '../../../../../../data/dietitian/domain/dietitian';
import { DietitianStateProvider } from '../../../../../../data/dietitian/domain/dietitian_state_provider';
import { InvitationTemplate } from '../../../../../../data/dietitian/domain/invitation_template/invitation-template';
import { InvitationTemplateCommands } from '../../../../../../data/dietitian/domain/invitation_template/invitation-template-commands';
import {
  Patient,
  PatientProps,
} from '../../../../../../data/patient/domain/patient';
import { PatientCommands } from '../../../../../../data/patient/domain/patient_commands';

export interface AccountViewModel {
  isLoading: boolean;
  error: string;
  dietitian: Dietitian;
}

@Injectable()
export class CreatePatientFacade {
  isLoading = false;

  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private patientCommands: PatientCommands,
    private invitationTemplateCommands: InvitationTemplateCommands,
  ) {
    // do nothing
  }

  get accountStatus$(): Observable<AccountViewModel> {
    return this.dietitianStateProvider.state$.pipe(
      map((e) => {
        return <AccountViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          dietitian: e.entity,
        };
      }),
    );
  }

  async createPatient(
    patientProps: PatientProps,
    dietitianId: string,
    sendInvitationEmail: boolean,
    invitationTemplate: InvitationTemplate | undefined,
  ): Promise<Patient> {
    const patient = await this.patientCommands.create(patientProps);
    if (sendInvitationEmail && patient?.email && invitationTemplate) {
      // Sauvegarde du modèle d'invitation
      if (invitationTemplate.id.toValue() === -1) {
        invitationTemplate = await this.invitationTemplateCommands.saveTemplate(
          dietitianId,
          invitationTemplate,
        );
      }
      // Envoi du message
      await this.patientCommands.sendInvitationEmailToPatient(
        dietitianId,
        patient,
        invitationTemplate,
      );
    }
    return patient;
  }
}
